<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" type="primary" icon="plus" @click="tableAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit" :disabled="!tableSelectedRows.length || tableSelectedRows.length !== 1">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiPromotionPosterListQuery">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="海报查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">海报名称：</div>
						<a-input v-model="query.posterTitle" style="width: 100%;" placeholder="请输入海报名称" allowClear />
					</div>
					<div style="display: flex; justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiPromotionPosterListQuery">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						推广海报列表
					</a-breadcrumb-item>
				</a-breadcrumb>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="promotionPosterId" :loading="tableLoading" :pagination="false">
				<span slot="posterTitle" slot-scope="text, record">
					<a-button type="link" @click="edit(record)" >{{record.posterTitle}}</a-button>
				</span>
				<span slot="posterImage" slot-scope="text, record">
					<img :src="baseUrl + record.posterImage" style="width: 50px; height: 50px; cursor: pointer;" @click="preview(record.posterImage)" />
				</span>
				<span slot="posterState" slot-scope="text, record">
					{{record.posterState === 3 ? '启用' : '禁用'}}
				</span>
				<span slot="facilitatorId" slot-scope="text, record">
					{{ facilitatorList.find(item => item.facilitatorId == record.facilitatorId).facilitatorName }}
				</span>
				<span slot="createTime" slot-scope="text, record">
					{{moment(record.createTime).format('YYYY-MM-DD HH:mm:ss')}}
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->
		<a-modal class="qa-modal-half" title="添加" width="600px" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false" >
            <a-form-model ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
				<a-form-model-item label="海报名称" has-feedback prop="posterTitle">
					<a-input v-model="addForm.posterTitle" placeholder="请输入海报名称" />
				</a-form-model-item>
				<a-form-model-item label="海报底图" has-feedback prop="posterImage">
					<ImageUpload 
                        v-model="addForm.posterImage" 
                        :limit="1" 
                        :fileSize="2" 
                        :fileType="['png', 'jpg', 'jpeg']" 
                        :isShowTip="true"
                        @input="uploadPicUrlAdd"
                    />
				</a-form-model-item>
				<a-form-model-item label="服务商" has-feedback prop="facilitatorId">
					<a-select v-model="addForm.facilitatorId" placeholder="请选择服务商">
						<a-select-option v-for="item in facilitatorList" :key="item.facilitatorId" :value="item.facilitatorId">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="状态" has-feedback prop="posterState">
					<a-radio-group v-model="addForm.posterState">
						<a-radio v-for="item in posterState" :key="parseInt(item.value)" :value="parseInt(item.value)">{{item.label}}</a-radio>
					</a-radio-group>
				</a-form-model-item>
			</a-form-model>
		</a-modal>

		<!-- 修改弹窗 -->
		<a-modal class="qa-modal-half" title="修改" width="600px" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false" >
			<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 5}" :wrapper-col="{span: 17}" :rules="addRules">
				<a-form-model-item label="海报名称" has-feedback prop="posterTitle">
					<a-input v-model="editForm.posterTitle" placeholder="请输入海报名称" />
				</a-form-model-item>
				<a-form-model-item label="海报底图" has-feedback prop="posterImage">
                    <ImageUpload 
                        v-model="editForm.posterImage"
                        :limit="1" 
                        :fileSize="2" 
                        :fileType="['png', 'jpg', 'jpeg']" 
                        :isShowTip="true"
                        @input="uploadPicUrlEdit"
                    />
                </a-form-model-item>
				<a-form-model-item label="服务商" has-feedback prop="facilitatorId">
					<a-select v-model="editForm.facilitatorId" placeholder="请选择服务商">
						<a-select-option v-for="item in facilitatorList" :key="item.facilitatorId" :value="item.facilitatorId">{{item.facilitatorName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="状态" has-feedback prop="posterState">
					<a-radio-group v-model="editForm.posterState">
						<a-radio v-for="item in posterState" :key="parseInt(item.value)" :value="parseInt(item.value)">{{item.label}}</a-radio>
					</a-radio-group>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		<!-- 图片预览弹窗 -->
		<a-modal title="海报预览" :visible="previewVisible" @cancel="handlePreviewCancel" :footer="null" width="800px">
			<img :src="baseUrl + previewImage" style="width: 100%; height: auto;" />
		</a-modal>
	</div>
</template>

<script>
	import moment from 'moment'
    import ImageUpload from '@/components/ImageUpload'
	export default {
        components:{
            ImageUpload
        },
		data() {
			return {
				moment,
				baseUrl: this.navigation.url,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					posterTitle: '',
				},
				tableData: [],
				tableColumns: [
                    { title:'ID', dataIndex:'promotionPosterId', key:'promotionPosterId', align:'center'},
					{ title:'海报名称', key:'posterTitle', align:'center',scopedSlots:{customRender:'posterTitle'}},
					{ title:'服务商', key:'facilitatorId', align:'center', scopedSlots:{customRender:'facilitatorId'}},
					{ title:'海报底图', key:'posterImage', align:'center', scopedSlots:{customRender:'posterImage'}},
					{ title:'状态', key:'posterState', align:'center', scopedSlots:{customRender:'posterState'}},
					{ title:'创建时间', key:'createTime', align:'center', scopedSlots:{customRender:'createTime'}}
				],
				tableLoading: false,
				tableSelectedRows: [],
				facilitatorList: [],
				posterState:[
                    {value:3,label:'启用'},
                    {value:2,label:'禁用'},
                ], 
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					posterTitle: '',
					posterImage: '',
					posterState: 3,
				},
				addRules: {
					posterTitle: [{ required: true, message: '海报名称不能为空', trigger: 'blur' }],
					posterImage: [{ required: true, message: '请上传海报底图', trigger: 'change' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					promotionPosterId: '',
					posterTitle: '',
					posterImage: '',
					posterState: 3,
				},
				// 修改弹窗-end
				// 图片预览-start
				previewVisible: false,
				previewImage: '',
				// 图片预览-end
			};
		},
		methods: {
			//获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList,{staffId:window.sessionStorage.getItem('staffId')});
				if (res.code == 200) {
					this.facilitatorList = res.data
				} else {
					this.$message.error(res.msg)
				}
			},
			//--------------表格开始-搜索
			async apiPromotionPosterListQuery() {
				this.tableLoading = true
				this.query.staffId = window.sessionStorage.getItem('staffId')
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPromotionPosterQueryList, this.query);
				if (res.code == 200) {
					this.tableLoading = false
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiPromotionPosterListQuery()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiPromotionPosterListQuery()
			},
			handleCancel() {
				this.addVisible = false
				this.editVisible = false
			},
			handlePreviewCancel() {
				this.previewVisible = false
				this.previewImage = ''
			},

			// 添加
			tableAdd() {
				this.addVisible = true
				this.addConfirmLoading = false
				this.addForm = {
					posterTitle: '',
					posterImage: '',
					posterState: 3,
					facilitatorId: undefined,
				}
				if(this.$refs.addRuleForm) {
					this.$refs.addRuleForm.resetFields();
				}
			},
			async apiPromotionPosterAdd() {
				this.addConfirmLoading = true
				this.addForm.staffId = window.sessionStorage.getItem('staffId')
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPromotionPosterAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					if(this.$refs.addRuleForm) {
						this.$refs.addRuleForm.resetFields();
					}
					this.addConfirmLoading = false
					this.addVisible = false
					// 等待弹窗关闭后再刷新列表
					this.apiPromotionPosterListQuery()
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiPromotionPosterAdd()
					} else {
						return false;
					}
				});
			},

			// 修改
			async edit(item){
				this.editConfirmLoading = false
				// 设置表单数据
				this.editForm = { ...item }
				// 先打开弹窗
				this.editVisible = true
			},
			async apiPromotionPosterEdit() {
				this.editConfirmLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPromotionPosterEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.editConfirmLoading = false
					this.editVisible = false
					// 等待弹窗关闭后再刷新列表
					this.apiPromotionPosterListQuery()
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiPromotionPosterEdit()
					} else {
						return false;
					}
				});
			},
			editHandleCancel() {
				this.editVisible = false
			},
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.length > 0) {
					const ids = this.tableSelectedRows.map(row=>row.promotionPosterId)
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: '当前选中' + ids.length + '条数据。',
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiPromotionPosterDel(ids)
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiPromotionPosterDel(ids) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPromotionPosterDel, ids);
				if (res.code == 200) {
					this.$message.success(res.msg)
					await this.apiPromotionPosterListQuery()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableEdit() {
				if(this.tableSelectedRows.length === 1) {
					const item = this.tableData.find(item => item.promotionPosterId == this.tableSelectedRows[0].promotionPosterId)
					this.edit(item)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
            //文件上传-开始
            uploadPicUrlAdd(val){
                this.addForm.posterImage = val
            },
            uploadPicUrlEdit(val){
                this.editForm.posterImage =val
            },
			// 文件上传-结束
			// 图片预览
			preview(image) {
				this.previewImage = image
				this.previewVisible = true
			}
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					onChange: (selectedRowKeys, selectedRows) => {
						that.tableSelectedRows = selectedRows;
					},
				};
			},
		},
		created() {
			this.apiPromotionPosterListQuery()
			this.apiFacilitatorList()
		}
	};
</script>

<style scoped>

</style>
